import React from 'react';
import { Text } from '@10d/tend-ui-typography';

const Description = ({ children }) => {
    return React.createElement(Text, null, children);
};
Description.displayName = 'Drawer.Description';

export { Description };
